<template>
  <div class="wrapper userorder-container">
    <div class="userorder-type-box clearfix">
      <div
        v-for="(val, key) in types"
        :key="key"
        @click="changeType(key)"
        class="userorder-type-item"
        :class="{
          active: val.active
        }">
        {{ val.text }}
        <span class="underline"></span>
      </div>
    </div>
    <div class="userorder-orderlist">
      <ul class="userorder-orderlist-box">
        <li
          v-for="item in orders"
          :key="item.order_no">
          <single-order :orderData="item" />
        </li>
      </ul>
      <div class="kong-state" v-if="firstFetching">
        <span class="loading mini-loading"></span>
        <p style="margin-top: 25px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;loading . . .</p>
      </div>
      <mugen-scroll v-else :handler="getNextPage" :should-handle="!fetching && (orders.length < total)">
        <div class="kong-state">
          <span v-show="orders.length < total" class="loading mini-loading"></span>
          <p v-show="orders.length < total" style="margin-top: 50px;">loading . . .</p>
          <p v-show="orders.length === total && total !== 0" style="margin-top: 50px;">--- this is the end, no more orders ---</p>
          <p class="empty-order-img" v-show="orders.length === 0 && !fetching" style="margin-top: 50px;">
            <img src="@/assets/img/comet/user/orderempty@2x.png" alt="">
          </p>
          <p v-show="orders.length === 0 && !fetching" style="margin-top: 50px;">--- no such kind of orders yet. ---</p>
        </div>
      </mugen-scroll>
    </div>
  </div>
</template>

<script>
import SingleOrder from './SingleOrder'
import MugenScroll from 'vue-mugen-scroll'
import api from '../../../api'
export default {
  name: 'UserOrders',
  components: {
    'single-order': SingleOrder,
    MugenScroll
  },
  data () {
    return {
      types: {
        'all': {
          text: 'All',
          active: true,
          state: ''
        },
        'wait_pay': {
          text: 'Waiting for checkout',
          active: false,
          state: '1'
        },
        'refund': {
          text: 'Refund',
          active: false,
          state: '4,5'
        }
      },
      fetching: true,
      orders: [],
      page: 1,
      total: 0,
      page_size: 10,
      firstFetching: true
    }
  },
  mounted () {
    setTimeout(() => {
      api.getOrders({
        params: {
          page: this.page,
          page_size: this.page_size,
          state: ''
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.orders = res.data.data.list || []
          this.total = res.data.data.total
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops, something went wrong, please try again later.'
          })
        }
        this.fetching = false
        this.firstFetching = false
      })
    }, 1000)
  },
  methods: {
    getOrders () {
      if (this.fetching) return
      this.fetching = true
      let a = Object.keys(this.types).findIndex(el => {
        if (this.types[el].active) return true
        return false
      })
      let state = this.types[Object.keys(this.types)[a]].state
      api.getOrders({
        params: {
          page: this.page,
          page_size: this.page_size,
          state: state
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.orders = this.orders.concat(res.data.data.list || [])
          this.total = res.data.data.total
        } else {
          this.$toast({
            type: 'error',
            message: 'Oops, something went wrong, please try again later.'
          })
        }
        this.fetching = false
        this.firstFetching = false
      })
    },
    getNextPage (a) {
      if (this.fetching) return
      this.page += 1
      this.getOrders()
    },
    changeType (typeName) {
      if (this.types[typeName].active || this.fetching) return
      let obj = {
        'all': { text: 'All', active: false, state: '' },
        'wait_pay': { text: 'Waiting for checkout', active: false, state: '1' },
        'refund': { text: 'Refund', active: false, state: '4,5' }
      }
      obj[typeName].active = true
      this.types = obj
      this.total = 0
      this.page = 1
      this.orders = []
      this.firstFetching = true
      setTimeout(() => {
        this.getOrders()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
  .userorder-container {
    padding-top: 30px;
    color: #1A3D5E;
    .userorder-type-box {
      margin-bottom: 30px;
      .userorder-type-item {
        float: left;
        margin-right: 48px;
        font-size:14px;
        font-family:SFProDisplay-Regular,SFProDisplay;
        font-weight:400;
        color:rgba(54,85,114,1);
        line-height:14px;
        position: relative;
        cursor: pointer;
        .underline {
          position: absolute;
          width: 0%;
          left: 0;
          border-top: 2px solid #37CAD7;
          bottom: -8px;
          transition: all .2s ease-in-out;
        }
        &.active {
          color: #37CAD7;
          .underline {
            width: 100%;
          }
        }
        &:hover {
          .underline {
            width: 100%;
          }
        }
      }
    }

    .kong-state{
      text-align: center;
      font-size:14px;
      font-weight:400;
      color:#BAC4CE;
      margin-bottom: 80px;
      .mini-loading {
        transform: scale(.5);
      }
      img{
        width: 142px;
        height: 155px;
        margin-bottom: 29px;
      }
      .empty-order-img {
        text-align: center;
        img {
          width: 211px;
          height: unset;
          margin-bottom: 33px;
          margin-top: 200px;
        }
      }
    }
  }
</style>
